import React, { useState, useEffect, useRef } from "react";

import DropDown from "../elements/dropDown";
import DynamicTextarea from "../elements/DynamicTextarea";
import NoInputCalendar from "../DatePicker/noinputdatepicker";
import "../mapeDokumentacijaItem/flowSymbols.css";

import LinkPopup from "../LinkPopup";
import {
  getSafeDocumentHref,
  hasDocumentContent,
} from "../../utils/documentLinks";
import {
  ACCEPTED_EXTENSIONS,
  downloadActivityDocument,
} from "../../utils/activityDocuments";

const SYMBOL_TYPES = [
  { value: "start", label: "Početak" },
  { value: "activity", label: "Aktivnost" },
  { value: "control", label: "Kontrola" },
  { value: "decision", label: "Odluka" },
  { value: "end", label: "Kraj" },
];

export default function NewProcedureRow({
  designations,
  handleChangeNewProcedureRow,
  name,
  description,
  handleSelectDueDate,
  due_date,
  handleSelectNewProcedureResponsibleDesignations,
  responsibles,
  handleAddLink,
  handleChangeLink,
  links,
  handleSaveNewProcedureRow,
  handleDeleteNewProcedureRow,
  newProcedureRowValidationsError,
  handleAddNewMapaDocumentList,
  handleRejectMapaDukument,
  handleChangeNewMapaDocument,
  handleSaveNewMapaDocument,
  handleAddMapaDocumentName,
  handleRemoveMapaDocument,
  handleUploadMapaDocument,
  setActivityToDelete,
  newProcedureRow,
}) {
  const [openLinkPopup, setOpenLinkPopup] = useState(false);
  const [documentName, setDocumentName] = useState("");
  const [uploading, setUploading] = useState(false);
  const fileInputRef = useRef(null);

  const handleFileChosen = async (e) => {
    const file = e.target.files && e.target.files[0];
    e.target.value = "";
    if (!file || !handleUploadMapaDocument) return;
    setUploading(true);
    try {
      await handleUploadMapaDocument(true, null, file);
    } finally {
      setUploading(false);
    }
  };
  const rowDocuments = links || [];

  const handleAddDocumentName = () => {
    const name = documentName.trim();
    if (!name) return;
    handleAddMapaDocumentName(true, null, name);
    setDocumentName("");
  };

  const formatDateToObject = (date) => {
    const dateStringArray = date.split(" ");
    const dateWithoutTime = dateStringArray[0].split("-");

    return new Date(
      dateWithoutTime[0],
      +dateWithoutTime[1] - 1,
      dateWithoutTime[2]
    );
  };

  const taRef1 = useRef();
  const taRef2 = useRef();

  useEffect(() => {
    if (taRef1.current && taRef2.current) {
      const scrollHeight1 = taRef1.current.scrollHeight;

      const height2 = +taRef2.current.style.height.split("p")[0];

      if (scrollHeight1 > height2) {
        taRef2.current.style.height = `${scrollHeight1}px`;
      }
      taRef1.current.style.height = `${scrollHeight1}px`;
    }
  }, [name]);

  useEffect(() => {
    if (taRef1.current && taRef2.current) {
      const scrollHeight2 = taRef2.current.scrollHeight;

      const height1 = +taRef1.current.style.height.split("p")[0];

      if (scrollHeight2 > height1) {
        taRef1.current.style.height = `${scrollHeight2}px`;
      }
      taRef2.current.style.height = `${scrollHeight2}px`;
    }
  }, [description]);

  return (
    <>
    <ul
      className="poslovni-procesi-table-list new-procedure-row"
    >
      <li
        className="poslovni-procesi-table-item"
        style={{ justifyContent: "center" }}
      >
        <span style={{ color: "var(--mainColor)", fontWeight: "bold" }}>+</span>
      </li>
      <li
        className="poslovni-procesi-table-item"
        style={{ alignItems: "flex-start", flexDirection: "column" }}
      >
        <div style={{ width: "100%", marginTop: 0 }}>
          <select
            className="flow-symbol-select"
            value={newProcedureRow?.symbol_type || "activity"}
            onChange={(e) => handleChangeNewProcedureRow(e, "symbol_type")}
          >
            {SYMBOL_TYPES.map((st) => (
              <option key={st.value} value={st.value}>
                {st.label}
              </option>
            ))}
          </select>
        </div>
        {newProcedureRowValidationsError &&
          newProcedureRowValidationsError["symbol_type"] && (
            <div className="input-error-message">Obavezno polje</div>
          )}
        <textarea
          rows="1"
          onChange={(e) => {
            handleChangeNewProcedureRow(e, "name");
          }}
          value={name}
          className="dynamic-textarea-auto"
          ref={taRef1}
        />
        {newProcedureRowValidationsError &&
          newProcedureRowValidationsError["name"] && (
            <div className="input-error-message">Obavezno polje</div>
          )}
      </li>
      <li
        className="poslovni-procesi-table-item"
        style={{
          alignItems: "flex-start",
        }}
      >
        <textarea
          rows="1"
          ref={taRef2}
          className="dynamic-textarea-auto"
          onChange={(e) => {
            handleChangeNewProcedureRow(e, "description");
          }}
          value={description}
        />
        {newProcedureRowValidationsError &&
          newProcedureRowValidationsError["description"] && (
            <div className="input-error-message">Obavezno polje</div>
          )}
      </li>
      <li
        className="poslovni-procesi-table-item"
        style={{ display: "flex", alignItems: "flex-start" }}
      >
        <div
          style={{
            width: "55%",
            borderRight: "1px solid var(--mainColor)",
            height: "100%",
            display: "flex",
            alignItems: "flex-start",
            paddingTop: "2px",
          }}
        >
          <DropDown
            isMulti={true}
            list={designations}
            onChange={handleSelectNewProcedureResponsibleDesignations}
            selectedValues={responsibles}
            fontSize={12}
            paddingLeft={0}
            flexDirection="column"
            whiteSpace="wrap !important"
            valuePadding="0"
            control={{ alignItems: "flex-start" }}
          />
          {newProcedureRowValidationsError &&
            newProcedureRowValidationsError["activities_designations"] && (
              <div className="input-error-message">Obavezno polje</div>
            )}
        </div>
        <div
          style={{
            width: "45%",
            position: "relative",
            display: "flex",
            alignItems: "flex-start",
          }}
        >
          {/* <p
            style={{
              position: "absolute",
              top: "10px",
              left: "5px",

              fontSize: "16px",
            }}
          >
            {due_date}
          </p>
          <NoInputCalendar
            handleSelectDate={handleSelectDueDate}
            parentStartDate={due_date ? formatDateToObject(due_date) : ""}
          /> */}
          <textarea
            rows="1"
            onChange={(e) => {
              handleChangeNewProcedureRow(e, "due_date");
            }}
            value={due_date ? due_date : ""}
            className="dynamic-textarea-auto"
          />
        </div>
      </li>
      <li
        className="poslovni-procesi-table-item"
        style={{
          position: "relative",
          alignItems: "flex-start",
        }}
      >
        <ul
          style={{
            width: "80%",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
          }}
        >
          {rowDocuments.filter(hasDocumentContent).map((link) => {
            const href = getSafeDocumentHref(link.path);
            const label = String(link.name || "").trim() || link.path;
            return (
              <div className="document-entry" key={link.id}>
                {link.is_file ? (
                  <button
                    type="button"
                    className="document-file-button"
                    title="Preuzmite fajl"
                    onClick={() => downloadActivityDocument(link)}
                  >
                    {label}
                  </button>
                ) : href ? (
                  <a
                    className="document-path-link"
                    href={href}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    {label}
                  </a>
                ) : (
                  <span className="document-path-text">{label}</span>
                )}
                <button
                  type="button"
                  className="document-remove-button"
                  title="Uklonite dokument"
                  onClick={() => handleRemoveMapaDocument(true, null, link.id)}
                >
                  ×
                </button>
              </div>
            );
          })}
          <div className="document-name-input-wrapper">
            <input
              className="document-name-input"
              maxLength={255}
              placeholder="Naziv dokumenta"
              value={documentName}
              onChange={(e) => setDocumentName(e.target.value)}
              onKeyDown={(e) => {
                if (e.key === "Enter") {
                  e.preventDefault();
                  handleAddDocumentName();
                }
              }}
            />
            <button
              type="button"
              className="document-name-add-button"
              title="Dodajte naziv dokumenta"
              disabled={!documentName.trim()}
              onClick={handleAddDocumentName}
            >
              +
            </button>
          </div>
        </ul>

        <div
          style={{
            display: "flex",
            flexDirection: "column",
            paddingTop: "12px",
            paddingRight: "5px",
            alignItems: "center",
            gap: "4px",
          }}
        >
          <input
            ref={fileInputRef}
            type="file"
            className="document-file-input"
            accept={ACCEPTED_EXTENSIONS}
            onChange={handleFileChosen}
          />
          <button
            type="button"
            disabled={uploading}
            className="mapedokumentacijaitem-button"
            title="Otpremite fajl sa računara"
            onClick={() => fileInputRef.current && fileInputRef.current.click()}
          >
            <img alt="" src="/images/doc.png" />
          </button>
          <button
            type="button"
            disabled={uploading}
            className="mapedokumentacijaitem-button"
            onClick={() => {
              setOpenLinkPopup((state) => !state);
              handleAddNewMapaDocumentList(true);
            }}
          >
            <img alt="" src="/images/link.png" />
          </button>
        </div>
      </li>
      <li className="poslovni-procesi-table-item">
        <div className="new-procedure-options-block">
          <button
            type="button"
            className="employee-item-options-button"
            onClick={handleSaveNewProcedureRow}
          >
            <img src="/images/check.png" alt="im" />
          </button>
          <button
            type="button"
            className="employee-item-options-button"
            onClick={() => handleDeleteNewProcedureRow()}
          >
            <img src="/images/trash.png" />
          </button>
        </div>
      </li>
    </ul>
    {openLinkPopup && (
      <>
        <div className="loading"></div>
        <LinkPopup
          handleAddLink={handleAddLink}
          handleChangeNewMapaDocument={handleChangeNewMapaDocument}
          handleRejectMapaDukument={handleRejectMapaDukument}
          setOpenLinkPopup={setOpenLinkPopup}
          handleChangeLink={handleChangeLink}
          link={rowDocuments[rowDocuments.length - 1]}
          handleSaveNewMapaDocument={handleSaveNewMapaDocument}
          isNewRow={true}
        />
      </>
    )}
    </>
  );
}
